import React from 'react';
import { useAppContext } from '../context/AppContext';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiShare2, FiArrowRight } = FiIcons;

export default function SuccessModal() {
  const { isSuccessModalOpen, setIsSuccessModalOpen, lastPurchase } = useAppContext();
  if (!isSuccessModalOpen || !lastPurchase) return null;

  const shareText = encodeURIComponent(`🔥 I just claimed my spot on the 1-Million-Pixel Grid!\n\n📍 Coordinates: [${lastPurchase.x}, ${lastPurchase.y}]\n💀 Permanently locked. Forever.\n\nGet yours before the price jumps → `);
  const shareUrl = `https://twitter.com/intent/tweet?text=${shareText}`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4">
      <div className="relative w-full max-w-sm animate-slide-up">
        <div className="absolute -inset-[1px] rounded-2xl" style={{ background: 'linear-gradient(135deg, #00ff88, #00ccff)' }} />
        <div className="relative rounded-2xl overflow-hidden p-6 text-center" style={{ background: '#0a0014' }}>
          
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: 'rgba(0,255,136,0.15)', boxShadow: '0 0 30px rgba(0,255,136,0.3)' }}>
            <FiCheck className="text-green-400 text-3xl" />
          </div>

          <h2 className="text-2xl font-black text-white mb-1 uppercase tracking-wider" style={{ fontFamily: 'Impact, sans-serif' }}>Pixels Secured!</h2>
          <p className="text-gray-500 text-sm mb-5">Your block is permanently locked into the grid.</p>

          <div className="flex items-center gap-3 p-3 rounded-xl mb-5 text-left" style={{ background: 'rgba(0,255,136,0.05)', border: '1px solid rgba(0,255,136,0.2)' }}>
            <div className="w-14 h-14 rounded-lg overflow-hidden border border-green-500/30 shrink-0">
              <img src={lastPurchase.image} alt="Preview" className="w-full h-full object-cover" />
            </div>
            <div>
              <div className="font-black text-white text-sm">{lastPurchase.title}</div>
              <div className="text-green-400 font-mono text-xs mt-1">X:{lastPurchase.x} Y:{lastPurchase.y}</div>
              <div className="text-[10px] text-gray-600 mt-0.5">{lastPurchase.w}×{lastPurchase.h}px locked forever</div>
            </div>
          </div>

          <div className="space-y-2">
            <a href={shareUrl} target="_blank" rel="noopener noreferrer"
              className="w-full py-3 rounded-xl font-black text-sm uppercase tracking-widest text-white transition-all hover:scale-[1.02] flex items-center justify-center gap-2"
              style={{ background: '#1DA1F2', boxShadow: '0 0 15px rgba(29,161,242,0.3)', fontFamily: 'Impact, sans-serif', letterSpacing: '2px' }}>
              <FiShare2 /> Share to X (Twitter)
            </a>
            <button onClick={() => setIsSuccessModalOpen(false)}
              className="w-full py-3 rounded-xl font-bold text-sm text-gray-400 hover:text-white transition-all flex items-center justify-center gap-2"
              style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
              Back to Grid <FiArrowRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}